// extracted by css-extract-rspack-plugin
export default {"headerOffset":"AnchorTarget__headerOffset--wF6Me"};